/* Rekover v13 : panier latéral, barre d'achat collante, carrousel */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Panier latéral ---------- */
  function drawer() { return document.querySelector('[data-cart-drawer]'); }
  function openCart() {
    var d = drawer(); if (!d) return false;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cd-lock');
    return true;
  }
  function closeCart() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cd-lock');
  }
  function refresh(open) {
    return fetch(root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var d = drawer(); if (!d || !data['cart-drawer']) return;
        var html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = html.querySelector('[data-cart-drawer]');
        if (fresh) d.innerHTML = fresh.innerHTML;
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('.cart-link').forEach(function (link) {
          var c = link.querySelector('.cart-link__count');
          if (cart.item_count > 0) {
            if (!c) { c = document.createElement('span'); c.className = 'cart-link__count'; c.setAttribute('aria-hidden', 'true'); link.appendChild(c); }
            c.textContent = cart.item_count;
          } else if (c) { c.remove(); }
        });
        if (open) openCart();
      });
  }

  window.rkCartRefresh = refresh;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]') || !drawer()) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return refresh(true); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.cart-link');
    if (link && drawer() && !/\/cart\/?$/.test(location.pathname)) { e.preventDefault(); refresh(true); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    var ch = e.target.closest('[data-cart-change]');
    if (ch) {
      ch.disabled = true;
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: parseInt(ch.dataset.line, 10), quantity: parseInt(ch.dataset.qty, 10) }) })
        .then(function () { return refresh(false); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* ---------- Barre d'achat collante (fiche produit) ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-sticky-atc]');
    var target = document.querySelector('.buy__add');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
    }).observe(target);
    var src = document.querySelector('.product__price .price__current');
    var dst = bar.querySelector('[data-sticky-price]');
    if (src && dst && 'MutationObserver' in window) {
      new MutationObserver(function () { dst.textContent = src.textContent; }).observe(src, { childList: true, characterData: true, subtree: true });
    }
  }

  /* ---------- Carrousel produits ---------- */
  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-carousel-track]');
      if (!track || wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      function step() { var item = track.querySelector(':scope > *'); return item ? item.getBoundingClientRect().width + 20 : 300; }
      wrap.querySelectorAll('[data-carousel-prev]').forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); });
      wrap.querySelectorAll('[data-carousel-next]').forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); });
    });
  }

  function start() { initSticky(); initCarousels(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });
})();
